import React, { useCallback } from 'react';
import { List, Spin } from 'antd';
import { MenuCategoriesListItem } from 'widgets/menu';
import { setUiCartItemModal, setUiCommonModal } from 'app/store/reducers/ui.reducer';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { IMenuItemWithCategoryNameAndType } from 'entities/Menu/Menu.models';

export const MenuCategoryList = React.memo(function MenuCategoryList() {
  const dispatch = useAppDispatch();

  const { menu, loading, customerStoreId, storeId } = useAppSelector((state) => ({
    menu: state.menu.menuCollection?.categoriesToAsset ?? [],
    loading: state.menu.menuCollectionLoading,
    customerStoreId: state.customer.customerModel?.store?.id ?? null,
    storeId: state.store.storeModel?.id ?? null,
  }));

  const isDefaultMenu = !customerStoreId && !storeId;

  const handleMenuItemClick = useCallback(
    (item: IMenuItemWithCategoryNameAndType) => {
      if (isDefaultMenu) {
        dispatch(setUiCommonModal({ isVisible: true }));
        return;
      }
      dispatch(setUiCartItemModal({ isVisible: true, menuItem: item }));
    },
    [dispatch, isDefaultMenu]
  );

  const renderCategory = useCallback(
    (category: any) => (
      <MenuCategoriesListItem category={category} isDefaultMenu={isDefaultMenu} onMenuItemClick={handleMenuItemClick} />
    ),
    [handleMenuItemClick, isDefaultMenu]
  );

  return (
    <Spin spinning={loading} className="mt-2">
      <List dataSource={menu} renderItem={renderCategory} />
    </Spin>
  );
});
